import { unpackToDate } from '@campfire/hot-date';
import { Box, Typography } from '@material-ui/core';
import { WarningRounded } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import React, { useMemo } from 'react';
import { SmsConfirmationIndicators } from './SmsConfirmationIndicators';
import { RosteringsAvatars } from './RosteringsAvatars';
import { useUser } from '../../../../../global/auth/useUser';
import { GetRosterSmsConfirmationData_vm_draftRoster as DraftRoster } from './__generated__/GetRosterSmsConfirmationData';

const useStyles = makeStyles({
  smsInfoBox: {
    background: '#FFFBEB',
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: '16px',
  },
  warningIcon: {
    color: '#FBBF24',
    fontSize: '16px',
    padding: '12px 12px 12px 16px',
  },
});

interface Props {
  draftRoster?: DraftRoster;
}

export const SmsConfirmationInfo = (props: Props) => {
  const { draftRoster } = props;
  const classes = useStyles();
  const { user } = useUser();

  const publishedBy = useMemo(() => {
    if (draftRoster?.publishedRoster?.publishedByManager) {
      return `${draftRoster.publishedRoster.publishedByManager.profile.preferredName} ${
        draftRoster.publishedRoster.publishedByManager.profile.lastName
      } on ${unpackToDate(draftRoster.publishedRoster.datePublished).toFormat('dd MMM yyyy')}`;
    }
    if (draftRoster?.publishedRoster?.publishedByVolunteer) {
      return `${draftRoster.publishedRoster.publishedByVolunteer.profile.preferredName} ${
        draftRoster.publishedRoster.publishedByVolunteer.profile.lastName
      }  on ${unpackToDate(draftRoster.publishedRoster.datePublished).toFormat('dd MMM yyyy')}`;
    }
    return '';
  }, [draftRoster]);
  const activeRosterings = useMemo(() => draftRoster?.publishedRoster?.activeRosterings ?? [], [draftRoster]);
  const allRosterings = useMemo(() => draftRoster?.publishedRoster?.rosterings ?? [], [draftRoster]);
  const rosteredRosterings = useMemo(() => {
    return activeRosterings.filter((r) => r.sessionRosterings.length > 0) ?? [];
  }, [activeRosterings]);

  if (!user.orgInfo.smsEnabled) return null;
  return (
    <Box className={classes.smsInfoBox}>
      <WarningRounded className={classes.warningIcon} />
      <Box pt={1.5} pb={2} pl={0} pr={'16px'}>
        <Typography
          variant={'subtitle2'}
          style={{
            color: '#92400E',
            lineHeight: '18px',
            fontSize: '13px',
          }}
        >
          {'SMS reminder will be sent 24-48 hours prior to this activity.'}
        </Typography>
        {publishedBy ? (
          <Typography
            style={{
              color: '#B45309',
              fontSize: '13px',
              lineHeight: '18px',
              marginTop: '4px',
            }}
          >
            {`Managed roster, published by ${publishedBy}.`}
          </Typography>
        ) : null}
        <Box style={{ paddingTop: '8px', paddingBottom: '4px' }}>
          <SmsConfirmationIndicators activeRosterings={activeRosterings} allRosterings={allRosterings} />
        </Box>
        <Box width={'100%'} overflow={'hidden'}>
          <RosteringsAvatars rosterings={rosteredRosterings} />
        </Box>
      </Box>
    </Box>
  );
};
